module.exports = __webpack_public_path__ + "img/FlyingiPhone_Thiself.4b762b7f.jpg";